import React, {useEffect, useState} from 'react';
import {Button, Col, Dropdown, Row, Spin} from "antd";
import SpotCyberThreat from "../components/SpotCyberThreat";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {getSACCourses, updateSACAccessTracker} from "../../shared/rootActions";
import {DownloadOutlined, RightOutlined} from "@ant-design/icons";
import {SAC_DOWNLOAD_ASSETS_DEFAULT_TOPIC} from "../../shared/constants/globalConstants";
import {getUserToken} from "../../shared/helper";
import {LANGUAGE_LABELS} from "./SettingPage";
const SACAssetPage = () => {
    const {sac_courses, siteInfo, userStatusChecked} = useSelector((state) => state?.root || {});
    const { loading: sac_loading, courses } = sac_courses || {};

    const [downloadPackages, setDownloadPackages] = useState({});
    const dispatch = useDispatch();
    const availableCourses = courses || [];
    const {t} = useTranslation();
    //const supportedLang = siteInfo?.available_languages || {}
    const supportedLang = LANGUAGE_LABELS;

    useEffect(() => {
        dispatch(getSACCourses());
    }, []);

    useEffect(() => {
        availableCourses && availableCourses?.map((course) => {
            // parse course to retrieve downloadable content
            course?.content?.forEach((section) => {
                if (section?.name === SAC_DOWNLOAD_ASSETS_DEFAULT_TOPIC) {
                    const packages = [];
                    section?.modules?.forEach((module) => {
                        if (module?.visible) {
                            const lang = module?.name?.match(/\[*([\S]+)\]$/)[1];
                            if (lang && supportedLang.hasOwnProperty(lang)) {
                                packages.push({
                                    key: module.id,
                                    label: (
                                        <Row align="middle" gutter={24}>
                                            <Col span={2}>
                                                <DownloadOutlined/>
                                            </Col>
                                            <Col>
                                                <span>{supportedLang[lang]}</span>
                                            </Col>
                                        </Row>
                                    ),
                                    url: module?.contents[0]?.fileurl,
                                })
                            }
                        }
                    });
                    setDownloadPackages({
                        ...downloadPackages,
                        [course.id]: packages
                    });
                }
            });
        });

        //TODO: Sort languages alphabetically
    }, [availableCourses]);

    const handleDownload = (e, id) => {
        const downloadItem = downloadPackages[id]?.find((item) => (item.key === +e.key));
        if (downloadItem?.url) {
            const url = new URL (downloadItem.url);
            url.searchParams.set('token', getUserToken());
            let downloadLink = document.createElement('a');
            downloadLink.target = '_blank';
            downloadLink.download = t('pageutilities_navbar_assets');
            downloadLink.href = url;
            downloadLink.click();
            downloadLink.remove();
            updateSACAccessTracker(id, downloadItem?.key);
        }
    };

    const downloadMenuProps = (id) => ({
        items: downloadPackages[id],
        onClick: (e) => handleDownload(e, id),
    });

    return (
        <div className="main_page container">
            <section className="greeting">
                <h5 className="greeting_txt">{t('studentapp_sac_title')}</h5>
                <p className='greeting_desc'>
                    {t('studentapp_sac_desc')}
                </p>
                <div className="sac_banner_img"></div>
            </section>

            {
                sac_loading ? (
                    <Spin size={"large"} />
                ) : (
                    userStatusChecked && (
                        availableCourses?.length > 0
                            ? (
                                <section className={"sac-content-section"}>
                                    <div className={"page-controls"}>
                                        {/*Controls for filters, sorting etc go here*/}
                                    </div>
                                    <div className="module-container">
                                        {
                                            availableCourses?.map((course) => (
                                                <div className={"module-wrapper"} key={course?.id}>
                                                    <div className={"module-tags"}>
                                                        <span className={"age"}>{t('studentapp_sac_course_age_tag')}</span>
                                                        <span className={"category"}>{t('studentapp_sac_course_strands')}</span>
                                                    </div>
                                                    <div className={"module-content"}>
                                                        <div className={"module-details"}>
                                                            <h4>{course?.fullname}</h4>
                                                            <div className="pure_html" dangerouslySetInnerHTML={{__html: course?.summary}}></div>
                                                        </div>
                                                        <div className={"module-download"}>
                                                            {
                                                                (Object.keys(downloadPackages)?.length > 0) && (
                                                                    <Dropdown
                                                                        menu={downloadMenuProps(course.id)}
                                                                        disabled={!downloadPackages?.hasOwnProperty(course.id)}
                                                                    >
                                                                        <Button className={"sac-download-button"}><span><span>{t('studentapp_sac_course_button')}</span> <RightOutlined /></span></Button>
                                                                    </Dropdown>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div className={'sac_banner_wrap'}>
                                        <div className="left_icon"></div>
                                        <div className="right_part">
                                            <h6>{t('studentapp_sac_sac_banner_title')}</h6>
                                            <p>{t('studentapp_sac_sac_banner_text')}</p>
                                        </div>
                                    </div>
                                </section>
                            )
                            : (
                                <section className={"cyber_sec"}>
                                    <h4>{t('homepage_feature')}</h4>
                                    <SpotCyberThreat/>
                                </section>
                            )
                    )
                )
            }
        </div>
    );
};

export default SACAssetPage;
